import React from 'react';
import type { TimesheetsDatatableRow } from 'redux/modules/superreports-datatable.types';
import type { TagBase } from 'types/tag';
import { COLUMN_SIZE_MEDIUM } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import { TagsCell } from './TagsColumn';
import type { DatatableColumnGetter } from './types';

export interface TagListParams {
  tag: TagBase;
}

export const getTagListColumn: DatatableColumnGetter<Array<TagBase>, TagListParams> = (
  id: string,
  params
) => {
  const filterTagsForCurrentColumn = (tags: Array<TagBase>) => {
    const tagListId = params!.tag.id;
    return tags.filter(t => t.parent?.id === tagListId);
  };

  return {
    id,
    header: props => (
      <HeaderWithMenu
        {...props}
        label={params!.tag.name}
        filterTriggerSelector='[data-testid="taglist-filter-dropdown"]'
      />
    ),
    minSize: COLUMN_SIZE_MEDIUM,
    size: COLUMN_SIZE_MEDIUM,
    enableResizing: true,
    enableSorting: false,
    meta: {
      numeric: false,
      label: 'Tag',
      labelPlural: 'Tags',
      getValue: (hourTags: Array<TagBase> = []) => filterTagsForCurrentColumn(hourTags),
    },
    accessorFn: (row: TimesheetsDatatableRow) => filterTagsForCurrentColumn(row.tags),
    cell: props => <TagsCell {...props} />,
  };
};
